import { formatCSS } from '@/app/utils/helpers';
/**
 * Fix auto remove !important
 * @param style template css string
 * @returns style string
 */
export default (style: string): string => {
  style = formatCSS(style);
  const regex = new RegExp(/\n\s*!important;/g);
  style = style.replace(regex, '');
  return style;
};
